import { useState } from 'react'

import { Box, Text, Checkbox, Label } from 'theme-ui'
import PlusIcon from '../../icons/PlusFat'
import MinusIcon from '../../icons/MinusFat'
import Counter from './Counter'

function FilterSelect({ name, icon, values, type, filters, setFilters }) {
    const [isOpen, setIsOpen] = useState(false)

    const currentValues = values
        .filter((value) => value.type === type)
        .sort((a, b) => {
            return b.count - a.count
        })

    const changeCheckbox = (e) => {
        const checked = e.target.checked
        const value = e.target.value

        if (checked) {
            const filter = currentValues.find((f) => value === f.value)
            const newFilters = [...filters, filter.value]
            setFilters(type, newFilters)
        } else {
            const newFilters = filters.filter((f) => value !== f)
            setFilters(type, newFilters)
        }
    }

    return (
        <>
            <Box
                sx={{
                    height: 52,
                    display: 'flex',
                    alignItems: 'center',
                    borderBottomColor: 'border',
                    borderBottomWidth: 1,
                    borderBottomStyle: 'solid',
                    cursor: 'pointer',
                }}
                onClick={() => setIsOpen(!isOpen)}
            >
                <Box
                    sx={{
                        mr: 2,
                        display: 'flex',
                    }}
                >
                    {icon}
                </Box>
                <Text
                    sx={{
                        fontSize: 1,
                        flex: 1,
                        textTransform: 'uppercase',
                    }}
                >
                    {name}
                </Text>
                {filters.length > 0 && <Counter total={filters.length} />}
                {isOpen ? <MinusIcon /> : <PlusIcon />}
            </Box>

            {isOpen && currentValues && (
                <Box
                    sx={{
                        borderBottomColor: 'border',
                        borderBottomWidth: 1,
                        borderBottomStyle: 'solid',
                        py: 3,
                    }}
                >
                    {currentValues.map((e) => {
                        const checked = filters.some(
                            (filter) => filter === e.value
                        )
                        return (
                            <FilterItem
                                checked={checked}
                                key={e.value}
                                name={e.value}
                                count={e.count}
                                onChange={changeCheckbox}
                            />
                        )
                    })}
                </Box>
            )}
        </>
    )
}

export function FilterItem({ name, count, checked, onChange }) {
    return (
        <Label>
            <Box sx={{ display: 'flex', alignItems: 'center', height: 30 }}>
                <Box>
                    <Checkbox
                        checked={checked}
                        value={name}
                        onChange={onChange}
                    />
                </Box>
                <Text
                    sx={{
                        fontSize: 1,
                        display: 'flex',
                        color: 'textDarkGrey',
                        flex: 1,
                        textTransform: 'uppercase',
                    }}
                >
                    {name} ({count})
                </Text>
            </Box>
        </Label>
    )
}

export default FilterSelect
